import { useTheme } from '@mui/material';
import DeFiApplicationsIcon from '../../../public/svg/icons/xrplServices/DeFiPlatforms.svg';
import EnterpriseBlockchainSolutionsIcon from '../../../public/svg/icons/xrplServices/EnterpriseBlockchainSolutions.svg';
import PaymentRemittanceSolutionsIcon from '../../../public/svg/icons/xrplServices/PaymentAndRemmitance.svg';
import TokenizationPlatformsIcon from '../../../public/svg/icons/xrplServices/TokenizationPlatforms.svg';

export const XRPLBlockchainDevelopmentServicesData = {
  mainText: 'XRPL development made to measure',
  description: `Rumble Fish specializes in XRP Ledger development for fintech startups, enterprises, and institutions - building payment solutions, tokenization platforms, and DeFi applications that leverage XRPL's speed, low costs, and compliance features. Whether you're disrupting remittances, tokenizing assets, or building the next generation of financial infrastructure, we turn your vision into production-ready code.`,
};

export const AccordionData = () => {
  const theme = useTheme();
  return [
    {
      iconSvg: PaymentRemittanceSolutionsIcon,
      iconSvgAlt: 'payment-remittance-solutions-icon',
      title: 'Payment & Remittance Solutions',
      description: `
      Cross-border payments shouldn't take three business days and cost $40 per single wire. We build on-chain payment systems that move money faster than you can refresh your bank app.
      <ul>
        <li>Real-time payment processing systems</li>
        <li>Multi-currency settlement platforms</li>
        <li>Automated treasury management tools</li>
        <li>Remittance solutions that actually work</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      iconSvg: TokenizationPlatformsIcon,
      iconSvgAlt: 'tokenization-platforms-icon',
      title: 'Tokenization Platforms',
      description: `
      The tokenization market is expected to reach nearly <a href="https://www.binance.com/en/square/post/22612056697458" target="_blank">$19 trillion by 2033</a>, and the XRPL is purpose-built for this future. Get ahead of the competition and build your tokenization business with us.
      <ul>
        <li>Real-world asset (RWA) tokenization platforms</li>
        <li>Stablecoin issuance and management systems</li>
        <li>NFT marketplaces with actual utility</li>
        <li>Compliant token frameworks with built-in controls</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      iconSvg: DeFiApplicationsIcon,
      iconSvgAlt: 'defi-applications-icon',
      title: 'DeFi Applications',
      description: `
      The XRPL features a native decentralized exchange with integrated AMMs and 24/7 order books.
      <ul>
        <li>Decentralized exchange interfaces</li>
        <li>Liquidity pool management systems</li>
        <li>Automated trading strategies</li>
        <li>Yield optimization platforms</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      iconSvg: EnterpriseBlockchainSolutionsIcon,
      iconSvgAlt: 'enterprise-blockchain-solutions-icon',
      title: 'Enterprise Blockchain Solutions',
      description: `
      Banks don't want to "move fast and break things" - they want reliability, compliance, and performance. With over 10 years of error-free operation and $1+ trillion in transactions processed, the XRPL delivers institutional-grade infrastructure that actually works when billions are at stake.
      <ul>
        <li>Institutional-grade DeFi platforms with built-in KYC/AML compliance workflows</li>
        <li>Enterprise tokenization frameworks for securities, bonds, and structured products</li>
        <li>Private transaction systems using zero-knowledge proofs for confidential settlements</li>
        <li>Multi-signature treasury management with role-based access controls</li>
        <li>High-availability XRPL node infrastructure with 99.99% uptime SLAs</li>
        <li>Seamless integration with legacy banking systems and payment rails</li>
        <li>Regulatory reporting tools with audit trail and compliance monitoring</li>
        <li>White-label solutions for banks, asset managers, and financial institutions</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
  ];
};
